<template>
	<main-container>
		<material-card icon="far fa-id-card" :title="$t('adminclients.table_title')" importElement="AdminClients" :exportElement="{ element: 'AdminClients', types: ['xls'] }" :main_action="main_action" @mainAction="newAdminClients" :selected="selected_adminclients" @unselectAll="selected_adminclients = []">
			<template slot="delete-actions">
				<v-btn icon link @click="deleteAdminClients()">
					<v-icon>far fa-trash-alt</v-icon>
				</v-btn>
			</template>
			<template slot="filters">
				<v-col cols="12" xs="12" sm="5">
					<search-box v-model="adminclients_options.search" nocolor @change="adminclients_options.page = 1"></search-box>
				</v-col>
			</template>
			<material-table @click-action="editAdminClients" :selected.sync="selected_adminclients" show-select :headers="adminclients_headers" :items="adminclients.data" :options.sync="adminclients_options" :server-items-length="adminclients.total" :loading="adminclients_loading">
				<template v-slot:item.date="{ item }">{{ $formatters.frontEndDateFormat(item.date) }}</template>
				<template v-slot:item.payment_date="{ item }">{{ $formatters.frontEndDateFormat(item.payment_date) }}</template>
				<template v-slot:item.total="{ item }">
					<v-chip small color="success">{{ $formatters.formatCurrency(item.total) }}</v-chip>
				</template>
			</material-table>
		</material-card>
		<create-edit-adminclients v-if="showCreateEditAdminClients"></create-edit-adminclients>
		<import-adminclients v-if="showImportAdminClients"></import-adminclients>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		originaladminclients_options: null,
		selected_adminclients: [],
	}),
	computed: {
		showImportAdminClients() {
			return this.$store.getters.showImportAdminClients;
		},
		showCreateEditAdminClients() {
			return this.$store.getters.showCreateEditAdminClients;
		},
		main_action() {
			return {
				icon: "fas fa-plus",
				text: this.$vuetify.breakpoint.xsOnly ? this.$t("adminclients.mainaction_mobile") : this.$t("adminclients.mainaction"),
			};
		},
		adminclients_headers() {
			let headers = [];
			headers.push({
				text: this.$t("tenant.fullname"),
				value: "fullname",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("tenant.shortname"),
				value: "shortname",
				align: "left",
				sortable: true,
				selected: false,
			});
			headers.push({
				text: this.$t("tenant.taxcode"),
				value: "taxcode",
				align: "left",
				sortable: true,
				selected: false,
			});
			headers.push({
				text: this.$t("tenant.vatid"),
				value: "vatid",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("tenant.ateco"),
				value: "ateco",
				align: "left",
				sortable: true,
				selected: false,
			});
			headers.push({
				text: this.$t("tenant.redditivity"),
				value: "redditivity",
				align: "left",
				sortable: true,
				selected: false,
			});
			headers.push({
				text: this.$t("tenant.vat_year"),
				value: "vat_year",
				align: "left",
				sortable: true,
				selected: false,
			});
			headers.push({
				text: this.$t("tenant.email"),
				value: "email",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("tenant.phone"),
				value: "phone",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("tenant.whatsapp"),
				value: "whatsapp",
				align: "left",
				sortable: true,
				selected: true,
			});
			return { data: headers, id: "invoices_headers" };
		},
		adminclients_options: {
			get: function () {
				return this.$store.getters.getAdminClientsOptions;
			},
			set: function (value) {
				this.$store.commit("setAdminClientsOptions", value);
			},
		},
		adminclients() {
			return this.$store.getters.getAdminClients;
		},
		adminclients_loading() {
			return this.$store.getters.adminclients_loading;
		},
	},
	methods: {
		loadAdminClients() {
			const self = this;
			if (self.$functions.ObjectAreEqual(self.originaladminclients_options, self.adminclients_options) == false) {
				self.originaladminclients_options = _.cloneDeep(self.adminclients_options);
				self.$store.dispatch("fetchAdminClients");
			}
		},
		newAdminClients(selected) {
			let isCopy = false;
			if (selected) {
				delete selected.id;
				isCopy = true;
			} else {
				selected = {
					fullname: null,
				};
			}
			this.$store.commit("setCurrentAdminClients", _.cloneDeep(selected));
			this.$store.dispatch("showAction", "showCreateEditAdminClients");
			if (isCopy) {
				selected.fullname = selected.fullname ? selected.fullname + " " + this.$t("global.append_copy") : this.$t("global.append_copy");
				this.$nextTick(() => {
					this.$store.commit("setCurrentAdminClients", _.cloneDeep(selected));
				});
			}
		},
		editAdminClients(item) {
			this.$store.commit("setCurrentAdminClients", _.cloneDeep(item));
			this.$store.dispatch("showAction", "showCreateEditAdminClients");
		},
		deleteAdminClients() {
			const self = this;
			let message = self.$t("global.delete_confirm_message_pre");
			if (self.selected_adminclients.length <= 1) {
				message += self.$t("adminclients.question_selected");
			} else {
				message += self.selected_clients.length + self.$t("adminclients.question_multiple_selected");
			}
			self.$store.commit("showDialog", {
				type: "confirm",
				title: self.$t("global.delete_confirm_title"),
				message: message,
				okCb: () => {
					self.$store.dispatch("deleteAdminClients", _.map(self.selected_adminclients, _.property("id"))).then((res) => {
						self.$functions.actionOnSelection(res, self.selected_clients);
					});
				},
			});
		},
	},
	watch: {
		adminclients_options: {
			handler(val) {
				this.loadAdminClients();
			},
			deep: true,
		},
	},
};
</script>
